import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './i18n/index.js';
import './styles/themes.css';
import './styles/global.css';
import { App } from './App.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
